<template>
  <div class="flex flex-col flex-1">
    <vx-card class="vx-card_full-height">
      <div class="vx-row items-center justify-between flex-wrap flex-shrink-0">
        <div class="vx-col w-auto flex flex items-center flex-wrap">
          <h4 class="whitespace-no-wrap">Перерасчеты</h4>
          <div class="w-auto flex flex-wrap items-center ml-2">
            <div class="mr-2 mb-2">
              <label class="vs-input--label pl-1">Период с:</label>
              <datepicker
                v-model="date_from"
                class="datepicker_small"
                format="MMMM yyyy"
                :minimumView="'month'"
                :maximumView="'year'"
                :disabledDates="disabledDatesFrom"
              />
            </div>
            <div class="mr-2 mb-2">
              <label class="vs-input--label pl-1">По:</label>
              <datepicker
                v-model="date_to"
                class="datepicker_small"
                format="MMMM yyyy"
                :minimumView="'month'"
                :maximumView="'year'"
                :disabledDates="disabledDatesTo"
              />
            </div>
          </div>
        </div>

        <div class="vx-col w-auto flex items-center flex-shrink-0 md:flex-no-wrap flex-wrap">
          <!--          <vs-button-->
          <!--            type="border"-->
          <!--            v-if="$can('rp.charges', 'write')"-->
          <!--            @click="openCreate()"-->
          <!--            iconPack="feather"-->
          <!--            icon="icon-plus"-->
          <!--            title="Создать перерасчет"-->
          <!--          />-->
          <vs-button
            type="border"
            @click="$router.push({name: 'uc_b_recalculations_add'})"
            class="mb-2 mr-2 whitespace-no-wrap"
            v-if="$can('rp.recalculation', 'write')"
            iconPack="feather"
            icon="icon-plus"
            title="Добавить"
          >
            Добавить
          </vs-button>
          <vs-button
            class="mb-2" @click="exportTable()" iconPack="feather" icon="icon-download" type="border"
            title="Экспортировать в CSV"
          />
        </div>
      </div>

      <div class="pt-6 flex flex-col flex-1">
        <grid-infinite-scroll
          ref="table"
          :columns="recalculationsColumns"
          :rowsHeight="50"
          :getData="getData"
          :pageSize="pageSize"
          noRowsText="Перерасчеты не найдены"
        />

      </div>
    </vx-card>

    <vs-popup title="Информация о добавленном перерасчете" :active.sync="isNewsRecalculationInfoOpen">
      <div class="mb-4">
        Всего лицевых счетов: {{ newRecalculationInfo.total }}
      </div>
      <h5 class="mb-4 flex items-center">
        <feather-icon icon="CheckCircleIcon" class="mr-4" svg-classes="text-success" />
        Создано: {{ newRecalculationInfo.total - newRecalculationInfo.denied }}
      </h5>
      <h5 class="mb-4 flex items-center">
        <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger" />
        Ошибок: {{ newRecalculationInfo.denied }}
      </h5>
      <table class="w-full" v-if="newRecalculationInfo.errors && newRecalculationInfo.errors.length">
        <thead>
        <tr>
          <th class="p-0" style="width: 15%">Л/c</th>
          <th class="p-0">Помещение</th>
          <th class="p-0">Ошибка</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(error, index) in newRecalculationInfo.errors" :key="`key-${index}`">
          <td>{{ error.acc_num ? error.acc_num : '-' }}</td>
          <td>{{ error.apart_num ? error.apart_num : '-' }}</td>
          <td>{{ newRecalculationInfo.err_codes[error.code] }}</td>
        </tr>
        </tbody>
      </table>
    </vs-popup>
  </div>
</template>

<script>
import agActionsColumn       from "@/components/calculated-program/recalculations/agActionsColumn";
import notifyHttpError       from "@/mixins/notifyHttpError";
import RecalculationAccounts from "@/components/calculated-program/recalculations/RecalculationAccounts";
import formatDate            from "@/client/helpers/formatDate";
import stringify             from "qs/lib/stringify";

export default {
  name:       "Recalculation",
  mixins:     [notifyHttpError],
  components: {
    agActionsColumn,
    RecalculationAccounts,
  },
  data() {
    return {
      pageSize:                    50,
      date_from:                   (new Date()).setMonth((new Date()).getMonth() - 3), // now - 3 month
      date_to:                     Date.now(),
      recalculationsColumns:       [
        {
          headerName:            'Лицевые счета',
          field:                 'list',
          filter:                true,
          minWidth:              160,
          pinned:                "left",
          cellRendererFramework: RecalculationAccounts,
          cellRendererParams:    params => {
            if (!params.data) return null;
            return {
              recalculation: params.data,
            };
          },
          valueGetter:           ( { data, forExport } ) => {
            if (forExport) return data.list || 'Все';
            return data;
          },
          filterParams:          {
            filterOptions:        ["contains"],
            textCustomComparator: function ( filter, value, filterText ) {
              if (value.toLowerCase() === 'все') return true;
              let filterTextLoweCase = filterText.toLowerCase();
              let valueLowerCase = value.toString().toLowerCase();

              function contains( target, lookingFor ) {
                if (target === null) return false;
                return target.indexOf(lookingFor) >= 0;
              }

              return contains(valueLowerCase, filterTextLoweCase);
            },
          },
        },
        {
          headerName:  'Тип помещения',
          field:       'apartments_type',
          filter:      false,
          minWidth:    120,
          valueGetter: ( { data } ) => data.tarif && data.tarif.apartments_type !== null ? this.getApartmentsTypeById(data.tarif.apartments_type) : '-',
        },
        {
          headerName:  'Тип',
          field:       'apartment',
          minWidth:    180,
          flex:        2,
          filter:      false,
          valueGetter: ( { data } ) => this.getRecalculationTypeById(data.type),
        },
        {
          headerName:  'Тариф',
          field:       'tarifs',
          filter:      false,
          minWidth:    200,
          flex:        2,
          valueGetter: ( { data } ) => data.tarif ? data.tarif.name : "Не известный",
        },
        {
          headerName:  'Месяц',
          field:       'month',
          minWidth:    120,
          filter:      false,
          valueGetter: ( { data } ) => {
            return this.$options.filters.moment(this.$parseDateFromString(data.month), 'MMMM YYYY');
          },
        },
        {
          headerName:  'Сумма',
          field:       'value',
          minWidth:    100,
          filter:      "agNumberColumnFilter",
          valueGetter: ( { data } ) => data.value ? this.$options.filters.numberWithSpaces(Number(data.value)) : 0,
        },
        {
          headerName:   'Основание',
          field:        'comment',
          filter:       true,
          minWidth:     300,
          flex:         2,
          cellRenderer: ( cell ) => {
            return `<span title="${cell.value === null ? '' : cell.value}">${cell.value || ''}</span>`;
          },
        },
        {
          headerName:   'Комментарий',
          field:        'accountant_comment',
          filter:       true,
          minWidth:     120,
          flex:         1,
          cellRenderer: ( cell ) => {
            return cell.value !== null ? `<span title="${cell.value === null ? '' : cell.value}">${cell.value}</span>` : '';
          },
        },
        {
          headerName:  'Автор',
          field:       'who',
          filter:      false,
          minWidth:    160,
          valueGetter: ( { data } ) => data.who ? data.who.name : 'Не известно',
        },
        {
          headerName:            '',
          field:                 'actions',
          filter:                false,
          sort:                  false,
          minWidth:              120,
          maxWidth:              120,
          suppressExcelExport:   true,
          cellRendererFramework: agActionsColumn,
          cellRendererParams:    params => {
            if (!params.data) return null;
            return {
              params:      params.value,
              onEdit:      this.openEdit,
              onDelete:    this.resetData,
              buildingsId: this.selectedHouseId,
              id:          params.data.id,
            };
          },
          valueGetter:           ( { data, forExport } ) => {
            if (forExport) return null;
            return data;
          },
        },
      ],
      recalculationTypes:          [
        { value: 0, label: 'Фиксированная сумма на лицевой счет' },
        { value: 1, label: 'По площади' },
        { value: 2, label: 'По постоянно зарегистрированным' },
        { value: 3, label: 'По фактически проживающим' },
        { value: 4, label: 'Перерасчет на сумму начислений' },
      ],
      isNewsRecalculationInfoOpen: false,
      newRecalculationInfo:        {},
      isMounted:                   false,
    };
  },
  computed: {
    apartmentsTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },
    disabledDatesFrom() {
      return {
        from: new Date(this.date_to),
      };
    },
    disabledDatesTo() {
      return {
        to: new Date(this.date_from),
      };
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    openEdit( recalculation ) {
      this.$modal.open({
        size:           'md',
        title:          'Редактирование перерасчета',
        component:      () => import('@/components/employee/recalculations/RecalculationForm'),
        componentProps: {
          recalculation,
          onSave: ( body ) => {
            this.$vs.notify({ color: 'success', title: 'Перерасчет начался', text: 'Ожидайте окончания' });

            return this.$http.put(`/houses/${recalculation.buildings_id}/recalculation/${recalculation.id}`, body).then(
              ( { data } ) => {
                this.$vs.notify({ color: 'success', title: 'Перерасчет изменен', text: 'Перерасчет закончен' });
                this.isNewsRecalculationInfoOpen = true;
                this.newRecalculationInfo = data;
                this.resetData();
              },
              this.notifyHttpError,
            );
          },
        },
      });
    },

    openCreate() {
      this.$modal.open({
        size:           'md',
        title:          'Добавление перерасчета',
        component:      () => import('@/components/employee/recalculations/RecalculationForm'),
        componentProps: {
          onSave: ( body ) => {
            this.$vs.notify({ color: 'success', title: 'Перерасчет начался', text: 'Ожидайте окончания' });
            this.$http.post('recalculation', body).then(( { data } ) => {
              if (data === 'denied') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Ошибка расчета',
                  text:  'На данный месяц уже показаны квитанции',
                });
              } else {
                this.$vs.notify({ color: 'success', title: 'Перерасчет добавлен', text: 'Перерасчет закончен' });
                this.isNewsRecalculationInfoOpen = true;
                this.newRecalculationInfo = data;
                this.resetData();
              }
            }, this.notifyHttpError);
          },
        },
      });
    },

    getApartmentsTypeById( apartmentsId ) {
      let type = this.apartmentsTypes.find(type => type.id === apartmentsId);
      return type ? type.name : '-';
    },

    getRecalculationTypeById( typeId ) {
      let type = this.recalculationTypes.find(type => type.value === typeId);
      return type ? type.label : 'Не известный';
    },

    resetData() {
      const { table } = this.$refs;
      table && table.resetData();
    },

    getData( page, filters, orderBy ) {
      const params = {
        buildings_id: this.selectedHouseId,
        from:         this.$options.filters.formatDate(this.date_from),
        to:           this.$options.filters.formatDate(this.date_to),
        filters:      JSON.parse(filters),
        order_by:     [orderBy],
        page,
        per_page:     page ? this.pageSize : undefined,
        // ...convertOrderByToNewFormat(orderby),
      };
      return this.$http.get(`building/${this.selectedHouseId}/recalculation`, {
        params,
        paramsSerializer: ( params ) => stringify(params),
      }).then(
        ( { data } ) => ({
          response: data,
          total:    data.total,
          data:     data.data,
        }),
        ( e ) => {
          if (e.response && e.response.status === 403) {
            this.$store.commit('SET_FORBIDDEN', true);
          }
          return [];
        },
      );
    },

    exportTable() {
      const dateFrom = formatDate(new Date(this.date_from), 'LLLL yyyy');
      const dateTo = formatDate(new Date(this.date_to), 'LLLL yyyy');
      this.$refs.table.exportRows(`Перерасчеты ${dateFrom} - ${dateTo}.csv`);
    },
  },
  mounted() {
    this.isMounted = true;
  },
  watch: {
    selectedHouseId() {
      if (!this.isMounted) return false;
      this.resetData();
    },
    date_from() {
      if (!this.isMounted) return false;
      this.resetData();
    },
    date_to() {
      if (!this.isMounted) return false;
      this.resetData();
    },
  },
};
</script>

<style lang="scss">
.vdp-datepicker.has-error {
  input {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
  }
}

.vs-con-textarea.has-error {
  margin-bottom: 0;
  border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>
